import { useCallback } from 'react';
import { type MessageViewDataObject, isMessagePlaceholder } from '#models/services';
import { useAddChatroomMessageToCache, useDeleteChatroomMessageInCache, useUpdateChatroomsCache } from '../../../cache';

export const useReplaceChatroomMessageInCache = () => {
  const addChatroomMessageToCache = useAddChatroomMessageToCache();
  const deleteChatroomMessageInCache = useDeleteChatroomMessageInCache();
  const updateChatroomsCache = useUpdateChatroomsCache();

  return useCallback(
    ({ message, messageIdToReplace }: { message: MessageViewDataObject; messageIdToReplace: string }) => {
      deleteChatroomMessageInCache({ chatroomId: message.chatroom, messageId: messageIdToReplace });
      addChatroomMessageToCache({ chatroomId: message.chatroom, message });

      if (!isMessagePlaceholder(message)) {
        updateChatroomsCache({ chatroomId: message.chatroom, newMessage: message });
      }
    },
    [addChatroomMessageToCache, deleteChatroomMessageInCache, updateChatroomsCache],
  );
};
